import type { env as MoengageEnv } from '@moengage/web-sdk';
import Moe from '@moengage/web-sdk';

interface InitMoengageArgs {
  debug?: boolean;
  env?: MoengageEnv;
  workspaceId?: string | null;
}

export function initMoengage({ debug, env, workspaceId }: InitMoengageArgs) {
  if (!workspaceId) return;

  // eslint-disable-next-line import-x/no-named-as-default-member
  Moe.initialize({
    app_id: workspaceId,
    debug_logs: debug ? 1 : 0,
    env,
    cluster: 'DC_4',
    // Pinned: the 2.80.00 CDN build started creating anonymous (no-email)
    // profiles. Remove once that's resolved with MoEngage.
    sdkVersion: '2.79.02',
  });
}
